import { Route } from "@angular/router";

import { checkIfLoggedInFn, pmoEntity } from "../../core/guards";
import { PageMode } from "../../shared/constants/enums";
import { integrityRulesPageGuards } from "./_guards";
import { IntegrityRulesEditorComponent } from "./integrity-rules-editor/integrity-rules-editor";
import { IntegrityRulesListComponent } from "./integrity-rules-list/integrity-rules-list";

export const INTEGRITY_RULES_ROUTES: Route[] = [
  {
    path: "rules",
    canActivate: [checkIfLoggedInFn, pmoEntity, ...integrityRulesPageGuards],
    children: [
      {
        path: "",
        component: IntegrityRulesListComponent,
        data: {
          title: "rules_management.title",
          breadcrumb: "rules_management.title",
        },
      },
      {
        path: "create",
        component: IntegrityRulesEditorComponent,
        data: {
          breadcrumb: "rules_management.add_ruleset",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        component: IntegrityRulesEditorComponent,
        data: {
          breadcrumb: "rules_management.edit_ruleset",
          pageMode: PageMode.edit,
        },
      },
    ],
    data: {
      breadcrumb: "rules_management.title",
    },
  },
];
